"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _isClient = _interopRequireDefault(require("../utils/isClient"));

var _civicLogoC = _interopRequireDefault(require("../../assets/civic-logo-c.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100px;\n  width: auto;\n  animation-duration: 3s, 1s;\n  animation-name: rotate, fadeInOut;\n  animation-iteration-count: infinite, 1;\n  opacity: 0.4;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var stylesClass = (0, _emotion.css)(_templateObject());

var CivicLogoCAnimated = function CivicLogoCAnimated(_ref) {
  var alt = _ref.alt;
  return _isClient["default"] && _react["default"].createElement("img", {
    className: stylesClass,
    src: _civicLogoC["default"],
    alt: alt
  });
};

CivicLogoCAnimated.displayName = "Logo";
CivicLogoCAnimated.propTypes = {
  alt: _propTypes["default"].string
};
var _default = CivicLogoCAnimated;
exports["default"] = _default;